import axios from 'axios'

// create an axios instance
const baseURL = process.env.NODE_ENV === 'development' 
  ? '/' 
  : (process.env.VUE_APP_BASE_API || '/') // 添加兜底值

// console.log('Environment:', process.env.NODE_ENV)
// console.log('Base URL:', baseURL)

const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10 * 1000, // request timeout
  headers: {
    /* 'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', */
    /* post: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    } */
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    // 调试日志
    // console.log('Request config:', config)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    return response.data
  },
  error => {
    console.log('Response error:', error)
    return Promise.reject(error)
  })
export default service